<template>
  <div>
    <!--操作栏-->
    <Row type="flex" :space-x="10" class="margin-right-left padding-top" align="middle">
      <Cell>
        <Select v-model="year" style="width:120px" @change="loadList">
          <Option v-for="y in years" :value="y" :key="y">{{ y }}年</Option>
        </Select>
      </Cell>
      <Cell>
        <span class="tip">按月进行成本核算与结账，已结账期间不可修改</span>
      </Cell>
    </Row>

    <!--期间表格-->
    <div class="h-panel-body padding-top">
      <Table :datas="periods" :border="true" :loading="loading">
        <TableItem title="月份" :width="160">
          <template slot-scope="{data}">{{ data.year }}年{{ data.month }}月</template>
        </TableItem>
        <TableItem title="状态" :width="140" align="center">
          <template slot-scope="{data}">
            <Tag :color="statusColor(data.status)">{{ statusText(data.status) }}</Tag>
          </template>
        </TableItem>
        <TableItem title="操作" align="center">
          <template slot-scope="{data}">
            <span v-if="data.status === 1" class="link" @click="doCalculate(data)">核算</span>
            <span v-if="data.status === 2" class="link" @click="doCalculate(data)">重新核算</span>
            <span v-if="data.status === 2" class="link primary" @click="doClose(data)">结账</span>
            <span v-if="data.status === 3" class="muted">已锁定</span>
          </template>
        </TableItem>
      </Table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InventoryCostPeriod',
  data() {
    let now = new Date().getFullYear();
    let years = [];
    for (let y = now + 1; y >= now - 3; y--) {
      years.push(y);
    }
    return {
      year: now,
      years: years,
      periods: [],
      loading: false
    };
  },
  methods: {
    statusText(s) {
      return {1: '未核算', 2: '已核算', 3: '已结账'}[s] || '未核算';
    },
    statusColor(s) {
      return {1: 'default', 2: 'warning', 3: 'success'}[s] || 'default';
    },
    loadList() {
      this.loading = true;
      this.$api.pro.inventory.periodList(this.year).then(({data}) => {
        this.periods = data || [];
      }).finally(() => this.loading = false);
    },
    doCalculate(data) {
      this.$Confirm(`确认对 ${data.year}年${data.month}月 进行成本核算？`).then(() => {
        this.$api.pro.inventory.periodCalculate({year: data.year, month: data.month}).then(() => {
          this.$Message.success('核算完成');
          this.loadList();
        });
      });
    },
    doClose(data) {
      this.$Confirm(`确认结转 ${data.year}年${data.month}月？结账后该期间不可修改。`).then(() => {
        this.$api.pro.inventory.periodClose({year: data.year, month: data.month}).then(() => {
          this.$Message.success('结账成功');
          this.loadList();
        });
      });
    }
  },
  mounted() {
    this.loadList();
  }
};
</script>

<style lang="less" scoped>
.tip {
  color: #888;
  font-size: 13px;
}
.link {
  color: #2d8cf0;
  cursor: pointer;
  margin: 0 8px;
  &.primary {
    color: #19be6b;
  }
}
.muted {
  color: #aaa;
}
</style>
